/** Expiry is only a refresh hint. The server still validates the JWT signature and session. */
export function visualGameAccessNeedsRefresh(token, now_ms = Date.now()) {
  if (typeof token !== 'string') return true
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return true
    const payload = JSON.parse(globalThis.atob(parts[1].replaceAll('-', '+').replaceAll('_', '/')))
    return !Number.isFinite(payload.exp) || payload.exp * 1000 <= now_ms + 60000
  } catch { return true }
}
